import { capitalizeFirstCharOnly } from "@helper/stringTransform";
import { JSX } from "react";
import { twMerge } from "tailwind-merge";

type QuestionCardProps = {
  englishWord: string;
  options: string[];
  selectedWord: string | null;
  correctTamilWord: string;
  onWordClick: (word: string) => void;
  isMobile?: boolean;
  isQuickNews?: boolean;
};

function QuestionCard({
  englishWord,
  options,
  selectedWord,
  correctTamilWord,
  onWordClick,
  isMobile,
  isQuickNews = false,
}: QuestionCardProps): JSX.Element {
  return (
    <div
      className={twMerge(
        "flex flex-col items-center gap-4",
        isMobile ? "mt-lg mb-xl px-sm" : "my-lg min-w-[400px] w-[400px]",
        isQuickNews && "!my-0",
      )}
    >
      <div className="mb-0">
        <span
          id="staticEnglish_web"
          className={twMerge(
            `font-secondary font-semibold text-gray-100 text-2md`,
            isQuickNews && " text-sm",
          )}
        >
          {capitalizeFirstCharOnly(englishWord)} =
        </span>
      </div>
      <div className={`flex w-full flex-col ${isMobile && "items-center"}`}>
        <ul
          className={`inline-flex flex-col items-center gap-4 p-0 list-none ${isMobile && "w-full max-w-[375px]"}`}
        >
          {options.map((word, index) => (
            <div
              key={index}
              onClick={() => {
                onWordClick(word);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  onWordClick(word);
                }
              }}
              role="button"
              tabIndex={0}
              className={twMerge(
                "font-primary flex justify-center items-center w-full px-1.5 h-[40px] cursor-pointer text-gray-150 text-2sm lg:text-md leading-6 font-bold rounded-300",
                selectedWord !== null
                  ? word === selectedWord
                    ? word === correctTamilWord
                      ? "bg-green-400 text-white-100"
                      : "bg-red-800 text-white-100"
                    : `border-1 bg-gray-500 ${!isMobile && "lg:bg-white-100"}`
                  : `bg-gray-500 ${!isMobile && "lg:bg-white-100"}`,
              )}
            >
              {capitalizeFirstCharOnly(word)}
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default QuestionCard;
